import { render, staticRenderFns } from "./ContentLeftSideWidgedHolder.vue?vue&type=template&id=2f1bed06&scoped=true&"
import script from "./ContentLeftSideWidgedHolder.vue?vue&type=script&lang=js&"
export * from "./ContentLeftSideWidgedHolder.vue?vue&type=script&lang=js&"
import style0 from "./ContentLeftSideWidgedHolder.vue?vue&type=style&index=0&id=2f1bed06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1bed06",
  null
  
)

export default component.exports